<div class="pricing-container">
  <div class="pricing-headers">
    <div class="pricing-header pre-tax">
      <div>pre tax</div>
    </div>

    <div class="pricing-header">
      <div>out</div>
      <div>the door</div>
    </div>
  </div>
  <div class="prices-container">
    <div class="pre-tax">
      <app-column-primary-price
        [menu]="viewModel.cardStackMenu$ | push"
        [section]="viewModel.cardStack$ | push"
        [colVm]="viewModel.spoofedColViewModel$ | push"
        [rowVm]="viewModel.cardData$ | push"
        [locConfig]="viewModel.locationConfig$ | push"
        [locationId]="viewModel.locationId$ | push"
        [productStylingVm]="viewModel"
        [ignoreStylingForSaleText]="true"
        [leadingTextOriginalPriceWithoutSale]="'$'"
        [leadingTextSalePrice]="'$'"
        [overridePriceStream]="Types.LocationPriceStream.Default"
        [finalPriceStringModifier]="removeDollarSign">
      </app-column-primary-price>
    </div>

    <div class="taxes-in">
      <app-column-primary-price
        [menu]="viewModel.cardStackMenu$ | push"
        [section]="viewModel.cardStack$ | push"
        [colVm]="viewModel.spoofedColViewModel$ | push"
        [rowVm]="viewModel.cardData$ | push"
        [locConfig]="viewModel.locationConfig$ | push"
        [locationId]="viewModel.locationId$ | push"
        [productStylingVm]="viewModel"
        [hidePreviousPrice]="true"
        [leadingTextOriginalPriceWithoutSale]="'$'"
        [leadingTextSalePrice]="'$'"
        [overridePriceStream]="viewModel.priceStreamOverride$ | push"
        [finalPriceStringModifier]="removeDollarSign">
      </app-column-primary-price>
    </div>
  </div>
</div>
